import './OutstaffValue.css';
import { TEXTS } from '../../texts';


const OutstaffValue = () => {



  return (
    <div className="outstaff-value">

      <h2 className="outstaff-value-title">{TEXTS.DDTValueTitle}</h2>

      <div className="outstaff-value-wrapper">

        <div className="outstaff-value-card linear-hover">
          <div className="linear-hover-line"></div>
          <div className="outstaff-value-card-wrapper">
            <h3 className="outstaff-value-card_title">Geographical and<br />cultural proximity</h3>
            <span className="outstaff-value-card_number">{TEXTS.number01}</span>
          </div>
          <p className="outstaff-value-card_text">{TEXTS.DDTValueText_1}</p>
        </div>

        <div className="outstaff-value-card linear-hover">
          <div className="linear-hover-line"></div>
          <div className="outstaff-value-card-wrapper">
            <h3 className="outstaff-value-card_title">Reduce time spent<br />on recruitment</h3>
            <span className="outstaff-value-card_number">{TEXTS.number02}</span>
          </div>
          <p className="outstaff-value-card_text">{TEXTS.DDTValueText_2}</p>
        </div>

        <div className="outstaff-value-card linear-hover">
          <div className="linear-hover-line"></div>
          <div className="outstaff-value-card-wrapper">
            <h3 className="outstaff-value-card_title">Be flexible with<br />a team size</h3>
            <span className="outstaff-value-card_number">{TEXTS.number03}</span>
          </div>
          <p className="outstaff-value-card_text">{TEXTS.DDTValueText_3}</p>
        </div>

        <div className="outstaff-value-card linear-hover">
          <div className="linear-hover-line"></div>
          <div className="outstaff-value-card-wrapper">
            <h3 className="outstaff-value-card_title">85% of the team –<br />senior/middle engineers</h3>
            <span className="outstaff-value-card_number">{TEXTS.number04}</span>
          </div>
          <p className="outstaff-value-card_text">{TEXTS.DDTValueText_4}</p>
        </div>

        <div className="outstaff-value-card-long linear-hover-last">
          <div className="linear-hover-line-last"></div>
          <div className="outstaff-value-card-long-wrapper">
            <h3 className="outstaff-value-card_title">9.9/10 client<br />satisfaction score</h3>
            <span className="outstaff-value-card_number">{TEXTS.number05}</span>
          </div>
          <p className="outstaff-value-card-long_text">{TEXTS.DDTValueText_5}</p>
        </div>

      </div>
    </div>
  )
}

export default OutstaffValue;